import * as actionTypes from "./ActionTypes";

export const setUserCourseRole = (role) => {
  return {
    type: actionTypes.SET_USER_COURSE_ROLE,
    payload: role,
  };
};

// Store course approval status in Redux to persist across component remounts
// This prevents tabs from flickering during navigation
export const setCourseApprovalStatus = (courseId, status) => {
  return {
    type: actionTypes.SET_COURSE_APPROVAL_STATUS,
    payload: { courseId, status },
  };
};